if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        const quotaScript = this.querySelector('script.variant-quotas');
        try {
          this.variantQuotas = quotaScript ? JSON.parse(quotaScript.textContent) : {};
        } catch (e) {
          this.variantQuotas = {};
        }

        this.remainingRessources = document.getElementById("remaining-volume");
        this.checkForVolume = !!this.remainingRessources;
        if (!this.checkForVolume) {
          this.remainingRessources = document.getElementById("remaining-points");
        }
        this.ressourcesAdded = 0;

        if (this.checkForVolume) {
          const volumeScript = this.querySelector('script.variant-volumes');
          try {
            this.variantVolumes = volumeScript ? JSON.parse(volumeScript.textContent) : {};
          } catch (e) {
            this.variantVolumes = {};
          }
        } else {
          const pointsScript = this.querySelector('script.variant-points');
          try {
            this.variantPoints = pointsScript ? JSON.parse(pointsScript.textContent) : {};
          } catch (e) {
            this.variantPoints = {};
          }
        }
      }

      getRequestedQuantity() {
        const fd = new FormData(this.form);
        const raw = fd.get('quantity');
        const q = parseInt(raw, 10);
        return Number.isFinite(q) && q > 0 ? q : 1;
      }

      async precheckQuota(variantId, requestedQty) {
        const raw = this.variantQuotas?.[variantId];
        const quota = Number(raw);
        if (!Number.isFinite(quota) || quota <= 0) return { ok: true };

        let existingQty = 0;
        try {
          const cart = await fetch(`${window.routes.cart_url}.js`, { credentials: 'same-origin' }).then(r => r.json());
          const line = cart.items.find(i => String(i.id) === String(variantId) || String(i.variant_id) === String(variantId));
          existingQty = line?.quantity || 0;
        } catch (e) {
        }

        if (existingQty + requestedQty > quota) {
          return {
            ok: false,
            keepEnabled: existingQty < quota,
            message: `Ce produit est limité à ${quota} exemplaires pour cette vente.`,
          };
        }
        return { ok: true };
      }

      precheckVolume(variantId, requestedQty) {
        const perUnit = Number(this.variantVolumes?.[variantId]);
        const remaining = Number(this.remainingRessources.innerHTML);

        if (!Number.isFinite(perUnit) || perUnit <= 0) return { ok: true };
        if (!Number.isFinite(remaining)) return { ok: true };

        this.ressourcesAdded = perUnit * requestedQty;
        if (this.ressourcesAdded > remaining) {
          return {
            ok: false,
            message: `Volume restant insuffisant pour cette vente.`,
          };
        }
        return { ok: true };
      }

      precheckPoints(variantId, requestedQty) {
        const perUnit = Number(this.variantPoints?.[variantId]);
        const remaining = Number(this.remainingRessources.innerHTML);

        if (!Number.isFinite(perUnit) || perUnit <= 0) return { ok: true };
        if (!Number.isFinite(remaining)) return { ok: true };

        this.ressourcesAdded = perUnit * requestedQty;
        if (this.ressourcesAdded > remaining) {
          return {
            ok: false,
            message: `Points restants insuffisants pour cette vente.`,
          };
        }
        return { ok: true };
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const variantId = this.variantIdInput.value || this.form.querySelector('[name=id]')?.value;
        const requestedQty = this.getRequestedQuantity();
        const quotaCheck = await this.precheckQuota(variantId, requestedQty);
        if (!quotaCheck.ok) {
          this.handleErrorMessage(quotaCheck.message);
          this.submitButton.classList.remove('loading');
          if (quotaCheck.keepEnabled) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          CartPerformance.measureFromEvent("add:user-action", evt);
          return;
        }

        if (this.checkForVolume) {
          const volumeCheck = this.precheckVolume(variantId, requestedQty);
          if (!volumeCheck.ok) {
            this.handleErrorMessage(volumeCheck.message);
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
        } else {
          const pointsCheck = this.precheckPoints(variantId, requestedQty);
          if (!pointsCheck.ok) {
            this.handleErrorMessage(pointsCheck.message);
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
if (this.cart) {
  formData.append(
    'sections',
    this.cart.getSectionsToRender().map((section) => section.id)
  );
  formData.append('sections_url', window.location.pathname);
  this.cart.setActiveElement(document.activeElement);
}

const perUnitPoints = Number(this.variantPoints?.[variantId]);
if (!this.checkForVolume && Number.isFinite(perUnitPoints) && perUnitPoints > 0) {
  const totalPoints = perUnitPoints * requestedQty;
  // Store both: per-unit for consistency and total for checkout visibility
  formData.set('properties[_points_per_unit]', String(perUnitPoints));
  formData.set('properties[Points]', String(totalPoints));
}

config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            this.remainingRessources.innerHTML -= this.ressourcesAdded;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.innerHTML = `
            <span class="atc-with-icon">
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.25006 4V4.625H3.59423C2.79423 4.625 2.12423 5.22833 2.04006 6.02417L0.987564 16.0242C0.964673 16.242 0.987817 16.4621 1.05549 16.6704C1.12317 16.8787 1.23387 17.0704 1.38041 17.2331C1.52696 17.3958 1.70607 17.5259 1.90613 17.615C2.1062 17.704 2.32274 17.75 2.54173 17.75H15.4584C15.6774 17.75 15.8939 17.704 16.094 17.615C16.2941 17.5259 16.4732 17.3958 16.6197 17.2331C16.7663 17.0704 16.877 16.8787 16.9446 16.6704C17.0123 16.4621 17.0355 16.242 17.0126 16.0242L15.9601 6.02417C15.9197 5.64012 15.7385 5.28463 15.4516 5.02626C15.1646 4.76789 14.7921 4.62494 14.4059 4.625H12.7501V4C12.7501 3.00544 12.355 2.05161 11.6517 1.34835C10.9485 0.645088 9.99463 0.25 9.00006 0.25C8.0055 0.25 7.05168 0.645088 6.34841 1.34835C5.64515 2.05161 5.25006 3.00544 5.25006 4ZM9.00006 1.5C8.33702 1.5 7.70114 1.76339 7.2323 2.23223C6.76346 2.70107 6.50006 3.33696 6.50006 4V4.625H11.5001V4C11.5001 3.33696 11.2367 2.70107 10.7678 2.23223C10.299 1.76339 9.66311 1.5 9.00006 1.5ZM6.50006 8.375C6.50006 9.03804 6.76346 9.67393 7.2323 10.1428C7.70114 10.6116 8.33702 10.875 9.00006 10.875C9.66311 10.875 10.299 10.6116 10.7678 10.1428C11.2367 9.67393 11.5001 9.03804 11.5001 8.375V7.75C11.5001 7.58424 11.5659 7.42527 11.6831 7.30806C11.8003 7.19085 11.9593 7.125 12.1251 7.125C12.2908 7.125 12.4498 7.19085 12.567 7.30806C12.6842 7.42527 12.7501 7.58424 12.7501 7.75V8.375C12.7501 9.36956 12.355 10.3234 11.6517 11.0266C10.9485 11.7299 9.99463 12.125 9.00006 12.125C8.0055 12.125 7.05168 11.7299 6.34841 11.0266C5.64515 10.3234 5.25006 9.36956 5.25006 8.375V7.75C5.25006 7.58424 5.31591 7.42527 5.43312 7.30806C5.55033 7.19085 5.7093 7.125 5.87506 7.125C6.04082 7.125 6.1998 7.19085 6.31701 7.30806C6.43422 7.42527 6.50006 7.58424 6.50006 7.75V8.375Z" fill="white"/>
                </svg>
              </span>
              ${window.variantStrings.addToCart}
            </span>`;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
